export enum FirmStatus {
  ACTIVE = 'ACTIVE',
  DEFUNCT = 'DEFUNCT',
}
